// Порты, инъецируемые в createVoiceRecorder (keyhole-изоляция Тир 3).
//
// voice-recorder НЕ импортирует пакеты соседей (client-transport / media-pipeline / design-system
// ещё/или не нужны как код) — вместо этого здесь объявлены ЛОКАЛЬНЫЕ порты, спроецированные с
// замороженных контрактов соседей:
//   - TransportPort     ← client-transport §4.5/§4.6/§4.8 (отправка голосового + поток events()).
//   - MediaUploadPort   ← media-pipeline §4.5 (init/chunk/complete → Attachment), сведённый в
//                         один шаг uploadAudio (проекция, см. SPEC §4.5).
//   - MediaCaptureFactory ← браузерные getUserMedia/MediaRecorder/AudioContext по рецепту Diktum
//                         (SPEC §4.8). Дефолтная браузерная реализация — в src/capture.ts.
//
// Все доменные типы — из @tele-chat/shared-contracts; локальных дублей DTO/событий нет
// (инвариант shared-contracts №1). Когда client-transport/media-pipeline будут собраны, их
// публичные поверхности структурно подойдут под эти порты без правок здесь.
// ─────────────────────────────────────────────────────────────────────────────
// Ошибки захвата мика — нормализованные коды (§4.10).
// ─────────────────────────────────────────────────────────────────────────────
/** Имена DOMException, которые getUserMedia бросает при отказе/отсутствии устройства. */
export const MIC_DENIED_ERROR_NAMES = ['NotAllowedError', 'SecurityError', 'PermissionDeniedError'];
export const MIC_UNAVAILABLE_ERROR_NAMES = ['NotFoundError', 'DevicesNotFoundError', 'OverconstrainedError'];
//# sourceMappingURL=ports.js.map